import { createFileRoute } from '@tanstack/react-router'
import { NotificationsPage } from 'pages/notifications/NotificationsPage'

export const Route = createFileRoute('/notifications/')({
  component: NotificationsPage,
  staticData: {
    title: 'Notifications',
    layout: {
      showNavbar: true,
      showSearchBar: false,
      enforceMaxWidth: false,
      enableScrolling: false,
    },
  },
})
